export class NotationInformation {
    constructor(
        public minimum: number,
        public average: number,
        public maximum: number
    ) {}
}
